import { render } from "./inbox-tags.vue?vue&type=template&id=1d5d10d1"
import script from "./inbox-tags.vue?vue&type=script&lang=js"
export * from "./inbox-tags.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__